import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { BellRing, Sparkles } from "lucide-react";
import { useBetaStatus } from "@/hooks/useBetaStatus";

/** Phase 12 — BETA / PREVIEW labelling for declaration & witnessing workflows.
 * Prevents any reasonable person believing a Beta/test declaration is an official
 * WitnessYourVote election record for a live implementation. */
export const BetaPreviewNotice = ({ className = "" }) => {
  const beta = useBetaStatus();
  if (!beta?.beta_mode) return null;
  const msg = beta.messaging || {};
  return (
    <div className={`rounded-xl border border-blue-200 bg-blue-50/70 p-4 ${className}`}
         role="note" data-testid="beta-preview-notice">
      <div className="flex flex-wrap items-start gap-3">
        <Badge variant="outline" className="bg-primary text-white border-primary text-[10px] font-bold tracking-widest shrink-0">
          <Sparkles className="h-3 w-3 mr-1" /> BETA / PREVIEW
        </Badge>
        <div className="min-w-0 flex-1 basis-52">
          <p className="text-xs text-blue-950 leading-relaxed" data-testid="beta-preview-notice-text">
            {msg.preview_notice || "This feature is currently being tested as part of the WitnessYourVote BETA. Full election participation will open when WitnessYourVote officially launches."}
          </p>
        </div>
        <Button asChild size="sm" variant="outline"
                className="border-primary/40 text-primary hover:bg-primary/5 shrink-0 h-8 text-xs"
                data-testid="beta-preview-notify">
          <Link to="/beta#signup"><BellRing className="h-3.5 w-3.5 mr-1.5" /> NOTIFY ME WHEN IT OPENS</Link>
        </Button>
      </div>
    </div>
  );
};
